import React, { useState, useEffect } from "react";
import { postProvincia, getProvincias } from "../helpers/rutaProvincias";
import "../css/addrubroform.css";

const AddProvinciaForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    provincia: "",
  });

  const [provincias, setProvincias] = useState({
    data: [],
    loading: true,
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      provincia: formValues.provincia,
    };

    postProvincia(payload).then((resp) => {
      console.log(resp);

      if (resp?.ok === false) {
        alert("No se pudo guardar la provincia");
        return;
      }

      setFormValues({
        provincia: "",
      });

      if (setShow) setShow(false);
    });
  };

  useEffect(() => {
    getProvincias().then((datos) => {
      setProvincias({
        data: Array.isArray(datos?.provincias)
          ? datos.provincias
          : Array.isArray(datos)
          ? datos
          : [],
        loading: false,
      });
    });
  }, []);

  return (
    <>
      {!provincias.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-4">
                <label>Provincia</label>
                <input
                  type="text"
                  className="form-control"
                  name="provincia"
                  maxLength="30"
                  required
                  value={formValues.provincia}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default AddProvinciaForm;